import React, {
  MouseEventHandler,
  useCallback,
  useContext,
  useMemo,
} from 'react';
import { useTranslation } from 'react-i18next';
import { formatBRNumber } from '@utils/formatters';
import useSwr from '@hooks/useSwr';
import getPercentage from '@utils/percentage';
import { valueType } from 'antd/lib/statistic/utils';
import SessionContext from '@providers/Session/SessionContext';
import StatCard from '@components/StatCard';

const TradeIn = ({
  onClick,
  filters,
}: {
  onClick: MouseEventHandler<HTMLDivElement>;
  filters: any;
}) => {
  const { t } = useTranslation('dashboard');

  const { selectedApp, isMot } = useContext(SessionContext);

  const routeToFindData = isMot
    ? 'MOT'
    : selectedApp?.split('_').join('').toUpperCase();

  const { data } = useSwr(
    `/service-proxy/inventory/${routeToFindData}/dashboards/count-by-status`,
    {
      params: { status: isMot ? 'TRADE_IN' : 'READY_TO_USE' },
      method: 'post',
      data: {
        ...filters,
      },
    },
  );

  const formatStatisticValue = useCallback(
    (value: valueType) => formatBRNumber(value),
    [],
  );

  const percentage = useMemo(
    () => (data ? `(${getPercentage(data?.matching, data?.total, 2)}%)` : 0),
    [data],
  );

  return (
    <StatCard
      loading={!data}
      noData={data?.length === 0 || data?.total === 0}
      onClick={onClick}
      precision={0}
      suffix={percentage}
      title={t('trade-in')}
      value={data?.matching ?? 0}
      formatter={formatStatisticValue}
    />
  );
};

export default TradeIn;
